import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import styles from "./EstimatePDF.module.scss";
import classNames from "classnames/bind";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { title } from "process";
import { generateSectionPdf, generateSectionPdfByStep } from "./EstimatePDFExport";
import { Box, Button, IconButton, Modal, ModalProps } from '@mui/material';
import { CloseIcon } from "~/assets/icons";


const cx = classNames.bind(styles);

type ViewPdfModalProps = Omit<ModalProps, 'children'> & {
    data: any,
    step: number,
    onClose: () => void
};


export interface ChildHandle {
  exportPdf: () => void; 
}

const PAGE_WIDTH = 595;
const PAGE_HEIGHT = 842;

const DESIGN_WIDTH_PX = 928;
const SCALE = PAGE_WIDTH / DESIGN_WIDTH_PX;

const MARGIN_TOP = 40;
const MARGIN_BOTTOM = 40;


const ViewPdfModal = forwardRef<ChildHandle, ViewPdfModalProps>((props, ref) => {
    const { step,onClose, data, open, ...restProps } = props;

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    const exportPdfPro = async (step:number) => {
        let pdfBlob = await generateSectionPdfByStep(data, step);
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");
        onClose();
      // setPreviewUrl(pdfUrl);
    }

    useEffect(()=>{
        if(open){
            setPreviewUrl(null);
            exportPdfPro(step);
        }
    },[open])

    return <></>
    return (
        <Modal 
            open={open && previewUrl != null}
            {...restProps} >
            <Box className={cx('modal-container')}>
                <IconButton className='absolute top-[10px] right-[10px]' onClick={onClose}>
                    <CloseIcon className='w-[24px] h-[24px]' fill='#FF2D55' />
                </IconButton>
        
                <Box className={cx('content-container')}>
                    <iframe
                        src={previewUrl+"#navpanes=0&view=FitH&toolbar=0"}
                        style={{ width: "600px", height: "845px", border: "1px solid #ccc" }}
                    />
                </Box>
            </Box>
        </Modal>
    );
})

export default ViewPdfModal;